/* Ensure any element containing an MTooltipBasic becomes the positioning context
   so the absolute-positioned tooltip anchors to it. Inline-block forces inline
   parents (links, spans) to establish a proper containing block too. */
:where(*):has(> .m-tooltip-basic) {
  position: relative;
}

.m-tooltip-basic {
  /* Default positioning = bottom. Each modifier only overrides what differs. */
  position: absolute;
  z-index: 9999;
  top: calc(100% + var(--m-tooltip-basic-offset-y, var(--space-1-5)));
  left: calc(50% + var(--m-tooltip-basic-offset-x, 0px));
  right: auto;
  bottom: auto;
  transform: translateX(-50%);

  max-width: 250px;
  width: max-content;
  padding: var(--space-1) var(--space-2) var(--space-1-5);
  border-radius: var(--radius-default);

  background: var(--theme-grey);
  color: var(--text-on-dark);
  font-family: Arial, sans-serif;
  font-size: var(--font-size-xs);
  font-weight: 400;
  line-height: 1.4;
  white-space: pre-line;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 100ms ease-in-out,
    visibility 100ms ease-in-out;
}

/* Inner text — anchor font-size, line-height, family + weight again so parent
   styles (e.g. q-item's ~1.7em line-height, or a serif host) don't cascade through. */
.m-tooltip-basic__text {
  display: block;
  font-family: Arial, sans-serif;
  font-size: var(--font-size-xs);
  font-weight: 400;
  line-height: 1.4;
  color: inherit;
}

.m-tooltip-basic::before {
  /* Default arrow = points up (tooltip is below anchor). */
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
  border-radius: var(--radius-xs);
  top: -4px;
  bottom: auto;
  left: 50%;
  right: auto;
  transform: translateX(-50%) rotate(45deg);
}

/* --- position modifiers --- */

.m-tooltip-basic--top {
  top: auto;
  bottom: calc(100% + var(--m-tooltip-basic-offset-y, var(--space-1-5)));
}
.m-tooltip-basic--top::before {
  top: auto;
  bottom: -4px;
}

.m-tooltip-basic--right {
  top: calc(50% + var(--m-tooltip-basic-offset-y, 0px));
  left: calc(100% + var(--m-tooltip-basic-offset-x, var(--space-1-5)));
  transform: translateY(-50%);
}
.m-tooltip-basic--right::before {
  top: 50%;
  left: -4px;
  transform: translateY(-50%) rotate(45deg);
}

.m-tooltip-basic--left {
  top: calc(50% + var(--m-tooltip-basic-offset-y, 0px));
  left: auto;
  right: calc(100% + var(--m-tooltip-basic-offset-x, var(--space-1-5)));
  transform: translateY(-50%);
}
.m-tooltip-basic--left::before {
  top: 50%;
  left: auto;
  right: -4px;
  transform: translateY(-50%) rotate(45deg);
}

/* Show when the parent (or any ancestor with the tooltip as direct child) is
   hovered or contains the focused element. */
:where(*):hover > .m-tooltip-basic,
:where(*):focus-within > .m-tooltip-basic {
  opacity: 1;
  visibility: visible;
}
